export function JFrogDownload() {
    return function(url) {
        document.location = url;
    }
}